var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loader)?_c('Form',{attrs:{"url":"/renovacoes/config/valor/licencas/update","valor":_vm.valor}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }